import { hotelReservationConstants } from '@utils/constants';

export function compareOrdersByReservationStatus(a, b) {
    if (
        a.status === hotelReservationConstants.STATUSES.DELETED &&
        b.status === hotelReservationConstants.STATUSES.RESERVED
    ) {
        return 1;
    }

    if (
        b.status === hotelReservationConstants.STATUSES.DELETED &&
        a.status === hotelReservationConstants.STATUSES.RESERVED
    ) {
        return -1;
    }

    return 0;
}
